const ko = {
  test: "This is KO",
  submitted: "적용됨",
  email: "이메일",
  birth: "생년월일",
  gender: "성별",
  last_name: "성",
  first_name: "이름",
  postal_code: "우편번호",
  zip: "우편번호",
  province: "시/도",
  city: "도시",
  address1: "주소",
  address2: "상세 주소",
  phone_number: "전화번호",
  search_address: "검색",
  save: "저장",
  cancel: "취소",
  edit: "수정",
  delete: "삭제",
  subtotal: "주문 금액",
  shipping_fee: "배송비",
  discount: "할인",
  total_amount: "결제 금액",
  refunded_amount: "환불 금액",
  cancel_order: "주문 취소",
  request_return: "반품 신청",
  tracking_number: "송장 번호",
  payment_method: "결제 수단",
  male: "남성",
  female: "여성",
  "non-binary": "논바이너리",
  current_password: "현재 비밀번호",
  new_password: "새 비밀번호",
  confirm_new_password: "비밀번호 확인",
  view_detail: "자세히 보기",
  confirm: "확인",
  submit: "적용",
  deactivate: "회원 탈퇴",
  password: "비밀번호",
  notification: "알림",
  gift: "사은품",
  change: "변경",
  popup_close: "오늘 하루 보지 않기",
  return_shipping: "반품 배송비",
  order_status: {
    title: "주문 상태",
    refunded: "환불 완료",
    canceled: "취소됨",
    partially: "부분 환불됨",
    completed: "결제 완료",
    return: "반품 접수됨",
    return_approved: "반품 승인됨",
    shipped: "발송 완료",
    partially_shipped: "일부 발송 완료",
    scheduled: "예약 발송 전",
    scheduled_shipped: "예약 발송 준비 중",
    completed_shipped: "예약 발송 완료",
    preparing: "배송 준비 중",
    paid: "결제 완료",
    pending: "결제 확인 중",
    prizeCancel: "당첨 취소",
    drawCancel: "응모 취소",
    drawLose: "미당첨",
    drawWin: "**당첨**",
    drawApply: "응모 완료",
    gifting_pending: "선물 수락 대기중",
    gifting_accepted: "선물 수락 완료",
    preorder: "예약 발송",
  },
  account: {
    reset_password_email: "비밀번호를 재설정하기 위한 이메일을 보내드립니다.",
    login: "로그인",
    order_history: "주문 내역",
    draw_history: "응모 내역",
    event_history: "이벤트 참여 내역",
    shipping_address: "배송지 관리",
    log_out: "로그아웃",
    new_collection: "신상품 보러가기",
    return_history: "반품 내역",
    personal_information: {
      description:
        "아래의 페이지에서 회원 정보를 확인하고 편집할 수 있습니다.<br />주문 및 배송 관련 문의는 이메일 혹은 우측 하단 채팅 서비스를 통해 문의 해 주세요.",
      accepts_marketing: "마케팅 활용 및 광고성 이메일 수신 동의 (선택)",
      update_information: "변경사항 저장",
      employee: "계정입니다. (30% - 50% 상시 할인 혜택)",
    },
    reset_password: {
      description: "개인정보 보호를 위해 1년 이상 비밀번호를 변경하지 않은 경우 비밀번호 변경을 권장하고 있습니다.",
      request: "비밀번호 변경",
      title: "Reset Password",
    },
    forgot_password: {
      description: "Forgot your password? Reset here.",
      label: "비밀번호 찾기",
    },
    create_account: {
      description: "I agree to terms and conditions and privacy policies.",
      label: "계정 생성하기",
    },
    deactivation: {
      request: "회원 탈퇴 접수 시 회원 정보는 모두 삭제되며, 더 이상 스토어 서비스를 이용하실 수 없습니다.",
      ask: "정말 탈퇴하시겠습니까?<br />‘Confirm’ 버튼을 누르시면 회원 탈퇴를 진행합니다.",
      processing: "회원 탈퇴 처리중",
      description: "회원 탈퇴 접수 시 회원 정보는 모두 삭제되며, 더 이상 스토어 서비스를 이용하실 수 없습니다.",
    },
    social_login: {
      change_password: "현재 연결되어있는 소셜 로그인 서비스입니다.",
    },
    membership: {
      discount: "Benefit: {{amount}}",
      coupon: "Discount Code: 월간 코드 {{amount}}%",
      current: "나의 등급",
      next: "나의 예정 등급",
      view_detail: "멤버십 혜택 자세히 보기",
      view_membership_detail: "나의 멤버십 보기",
      my_membership: "멤버십 등급",
      more_info: "멤버십 혜택 자세히 보기",
      description_new: "{{storeName}} 멤버십을 통해 특별 할인 혜택과 함께 신상품 소식 및 이벤트 정보를 가장 먼저 받아보세요.",
      accumulated_amount1: "최근 1년 누적 금액은",
      accumulated_amount2: " {{amount}}원입니다.",
      next_level_new1: "{{next_level}} 등급까지",
      next_level_new2: " {{amount}}원 남았습니다.",
      employee_discount: "임직원 할인율 적용",
      benefit: {
        title: "할인 혜택",
        discount: "{{discount}} 상시할인",
        code: "{{code}} 할인코드 월 1회 지급",
      },
      amount: {
        current: "현재 누적 금액 {{amount}}",
        next: "{{membership}} 등급까지 {{amount}}",
      },
      member: {
        benefits: "상시 1% 할인",
        discount_code: "",
        purchase_amount: "₩0 이상 ₩300,000 미만",
      },
      silver: {
        benefits: "상시 3% 할인",
        discount_code: "월간 5% 할인코드 지급",
        purchase_amount: "₩300,000 이상 ₩2,000,000 미만",
      },
      gold: {
        benefits: "상시 5% 할인",
        discount_code: "월간 7% 할인코드 지급",
        purchase_amount: "₩2,000,000 이상 ₩5,000,000 미만",
      },
      platinum: {
        benefits: "상시 7% 할인",
        discount_code: "월간 10% 할인코드 지급",
        purchase_amount: "₩5,000,000 이상 ₩10,000,000 미만",
      },
      vip: {
        benefits: "상시 10% 할인",
        discount_code: "월간 15% 할인코드 지급",
        purchase_amount: "₩10,000,000 이상",
      },
      employee: {
        discount_code: "",
        benefits: "30% - 70% 상시 할인",
      },
      policy: {
        "1": "향후 멤버십 혜택 및 선정 기준은 추후 사전 고지 없이 변경될 수 있습니다.",
        "2": "회원 등급 혜택은 {{storeName}} 온라인 스토어에서만 적용 가능합니다.",
        "3": "등급별 할인 코드 혜택으로 매월 1일 오전 11시에 1회 사용할 수 있는 멤버십 전용 할인 코드가 발급되며, 익월 1일 오전 10시 59분까지만 사용 가능합니다. (마케팅 정보 수신 여부 및 마케팅을 위한 개인정보 수집 이용을 거부한 경우 각종 소식, 혜택에 제한이 있을 수 있습니다.)",
        "4": "등급 기준은 매월 1일 오전 11시부터 순차적으로 변경되며 변경일로부터 최근 3년 이내, 누적 실 결제금액 기준으로 적용됩니다.",
        "5": "멤버십 회원 등급은 총 주문 금액에서 취소 및 환불을 제외한 실 결제 금액을 기준으로 산정됩니다. 실 결제 금액은 할인 적용 후 배송비를 제외한 순수 상품 금액이며, 주문일로부터 7일이 경과한 이후에 합산됩니다.",
        "6": "할인 코드 사용의 경우 한 주문 건당 한 개의 코드만 사용 가능하며 타 할인 코드와 중복 사용이 불가능합니다.",
        "7": "일부 상품의 경우 할인 및 혜택 대상에서 제외됩니다.",
        "8": "회원 등급에 따른 혜택은 타인 양도가 불가합니다. (부정적인 방법을 통해 누적한 실적으로 의심되는 경우, 회원 등급이 강등될 수 있습니다.)",
        "9": "일부 할인 코드는 멤버십 상시 할인과 중복 적용이 불가할 수 있습니다.",
        "10": "발급된 코드는 사용과 동시에 소멸되며, 재발급 및 복원이 불가합니다.",
        "11": "발급된 코드는 사용과 동시에 소멸되며, 재발급 및 복원이 불가합니다.",
      },
      toss_policy: {
        "1": "토스 임직원 계정의 주문 금액 한도는 연 ₩2,000,000이며, 매년 1월 1일에 초기화됩니다.",
        "2": "누적 주문 금액과 장바구니 금액의 합이 주문 금액 한도를 초과하는 경우 주문을 진행할 수 없습니다. 장바구니 상품 및 금액을 조정하여 구매해 주세요.",
        "3": "상품의 할인율이 토스 임직원 할인 혜택으로 적용되는 할인율보다 높은 경우 상품 할인율만 적용됩니다.",
        "4": "일부 상품은 토스 임직원 할인 혜택이 적용되지 않으며, 할인 혜택이 적용되지 않은 상품을 구매하여도 누적 주문 금액에 포함됩니다.",
        "5": "토스 임직원 계정은 토스 임직원 할인 혜택을 제외한 별도의 할인 프로모션이 적용되지 않습니다.",
        "6": "퇴사 시에는 익월 1일에 계정이 비활성화 처리됩니다. 비활성화된 이후에는 로그인이 불가하여 문의사항이 있을 경우 우측하단 채널톡을 이용해주세요.",
      },
    },
    order: {
      none: "주문 내역이 없습니다.",
      amount: "주문 금액",
      invoice_number: "송장 번호",
      instagram: "인스타그램 계정",
      insta: "인스타그램",
      receive: "수령 방법",
      delivery: "택배 수령",
      pickup: "스토어 픽업",
      charge: "배송비",
      free: "무료 배송",
      total: "소계",
      payment_method: "결제 수단",
      payment: "결제 금액",
      address: "배송 주소",
      billing: "청구 주소",
      wait_alert: "결제 처리 중입니다.\n잠시만 기다려주세요.",
      pay: "결제하기",
      currency: "원",
      cancel_order: "주문 취소",
      return_order: "반품 신청",
      count: "개",
      unwanted: "단순 변심",
      defective: "상품 불량",
      size_large: "사이즈가 큼",
      size_small: "사이즈가 작음",
      already: "이미 응모하셨습니다.",
    },
    draw: {
      none: "응모 내역이 없습니다.",
      auto_pay: "자동 결제 수단",
      pickup_info: "픽업 정보",
      cancel_draw: "응모 취소",
      address: "수령 장소",
      default_address: "서울 성동구 성수이로7가길 3 1층",
      buy_period: "구매 기간",
      info: "유의 사항",
      info1: "구매 기간 내 미 구매시 당첨 취소",
      info2: "당첨자 본인 명의 카드로만 결제 가능",
      info3: "*당첨 내역 및 본인 신분증 지참, 대리 구매 및 수령 불가능",
      info4: "반품 및 환불 가능, 교환 불가능",
      info5: "*한정 수량으로 불량 발생 시 교환이 불가능한 점 양해 부탁드립니다.",
      kakao_info: "당첨 시 카카오 알림톡을 통해 상품 구매 기간 및 방법에 대한 안내를 드립니다.",
      follow: "을 팔로우 한 회원에 한하여 당첨됩니다.",
      already: "이미 응모에 참여하셨습니다.",
      draw: "응모하기",
      view_draw_history: "응모 내역 보기",
      cancel_item_ask: "\n제품 응모를 취소하시겠습니까?",
    },
    info: {
      me: "내 정보",
      agree: "아래 정보와 함께 마케팅 정보 수신 및 활용 동의 후 다양한 회원 혜택을 만나보세요.",
      card: "저장된 카드",
      card_save: "자주 사용하는 카드를 계정에 저장하고 관리해서 더욱 편리하게 결제해 보세요.",
      password: "비밀번호 변경",
      password_info: "개인정보 보호를 위해 1년 이상 비밀번호를 변경하지 않은 경우 비밀번호 변경을 권장하고 있습니다.",
      social: "소셜 로그인",
      social_current: "현재 연결되어있는 소셜 로그인 서비스입니다.",
      delete: "회원 탈퇴",
      delete_request: "회원 탈퇴 접수 시 회원 정보는 모두 삭제되며, 더 이상 스토어 서비스를 이용하실 수 없습니다.",
      delete_ask: "정말 탈퇴하시겠습니까?\n‘Okay’ 버튼을 누르시면 회원 탈퇴를 진행합니다.",
      current_password: "현재 비밀번호",
      new_password: "새 비밀번호",
      check_password: "비밀번호 확인",
      change_password: "비밀번호 변경하기",
      marketing_agree: "마케팅 정보 제공 수신",
      save_card: "저장된 카드 관리하기",
      male: "남",
      female: "여",
    },
    shipping: {
      add: "배송지 추가",
      add_address: "기본 배송지를 추가하여 더욱 빠르게 결제를 진행해보세요.",
      manage: "배송지 관리",
      manage_address: "기본 배송지를 변경하고 배송지 편집, 삭제를 진행할 수 있습니다.",
      none: "저장된 배송지가 없습니다.",
      edit: "배송지 수정",
      delete: "배송지 삭제",
      delete_ask: "저장된 배송지를 삭제하시겠습니까?",
      new_address: "배송지 추가하기",
      continue: "계속하기",
      address: {
        first_name: "이름",
        last_name: "성",
        zip: "우편번호",
        city: "시/도",
        address1: "주소",
        address2: "아파트 동/호수 등",
        phone: "전화 번호",
        set_default: "기본 배송지로 설정하기",
        save: "저장하기",
        add: "추가하기",
        find: "주소 검색",
        default: "기본 배송지",
      },
    },
    return: {
      order_id: "주문번호",
      select_item: "반품을 신청할 상품을 선택해 주세요.",
      alert_gift_return:
        "*사은품이 제공된 상품이 있습니다. 상품 반품 시 사은품을 동봉하지 않는 경우 반품 접수가 거절될 수 있으니 반드시 접수 전에 확인해 주세요.",
      method: "반품 신청하신 상품의 처리 방식을 확인해주세요.",
      method_description: "직접 발송을 희망하실 경우 채널톡 문의 바랍니다.",
      back: "뒤로가기",
      continue: "반품 신청하기",
      return_reason: "반품 사유",
      reason: "사유",
      add_photo: "불량 상품 사진을 제출해 주세요.",
      select_reason: "반품 사유를 선택해 주세요.",
      detail_reason_placeholder: "불량 현상에 관해 자세히 입력해 주세요.",
      channel_talk_notice: "*해당 상품의 반품은 채널톡을 통해 문의해 주세요.",
    },
    return_requested: {
      description: "반품 신청이 정상적으로 완료되었습니다.<br/>반품 승인 시 카카오 알림톡을 통해 안내드립니다.",
      return_shipping_fee: "반품 배송비",
      detail_reason: "상세사유",
    },
    checkout: {
      captcha: "아래에서 T, U, N, E를 찾아 클릭해 주세요.",
      save_card: "내 카드를 저장하고 더 빠르게 결제하세요. 일반 결제는 다른 결제수단을 선택하여 이용하실 수 있습니다.",
    },
  },
  raffles: {
    empty: "응모 내역이 없습니다.",
  },
  order_history: {
    description: "주문 내역을 한 눈에 확인해 보세요.<br/>주문을 클릭하면 배송지, 결제 정보와 같은 더 자세한 정보를 확인할 수 있습니다.",
    empty: "주문 내역이 없습니다.",
  },
  wishlist: {
    description: "마음에 드는 상품을 위시리스트에 저장해 보세요.<br/>원하는 항목을 한곳에 모아두고, 언제든지 확인할 수 있습니다.",
    empty: "위시리스트에 저장된 상품이 없습니다.",
    none: "위시리스트에 저장한 상품이 없습니다.",
    delete_ask: "위시리스트에서 해당 상품을 삭제하시겠습니까?",
  },
  address_book: {
    save_list: "저장된 주소",
    select_address: "이 주소 사용",
    create_new_address: "새로운 주소 추가하기",
    edit_address: "배송 주소 수정",
    set_as_default_address: "기본 배송지로 설정",
    description: "자주 사용하는 배송지를 저장하고 관리해 보세요.<br/>기본 배송지를 설정하면 더욱 빠르고 편리하게 주문할 수 있습니다.",
    delete_address: "배송지를 정말 삭제하시겠습니까?",
    save: "주소 저장",
    save_continue: "Save and continue",
    change: "주소 변경",
    use_other: "배송 주소 변경하기",
    default_address: "Default Address",
    in_use: "In Use",
    my_addresses: "My Addresses",
    empty: "No saved address yet.",
    change_address: "Use A Different Address",
    empty_address: "저장된 배송지가 없습니다.",
  },
  contact: {
    description: "주문 취소 및 반품 신청, 배송 추적은 내 계정의 주문내역에서 가능합니다.",
    order_history: "주문 내역 보기",
    my_membership: "나의 멤버십 등급 보기",
    membership: "최근 12개월간의 등급 점수를 기준으로, 매월 1일 새로운 멤버십 등급이 결정됩니다. 다양한 혜택을 확인해보세요.",
    working_hours: "평일 오전 9시 – 오후 5시",
    other_inquries: "그 외 기타 문의는 <email>{{supportEmail}}</email>을 이용해 주세요.",
    cs_info: "유선 상담은 운영하지 않습니다. 채팅 상담 및 메일로 문의 부탁드립니다.",
  },
  checkout: {
    notice: "시스템 문제로 인해 관세 및 세금이 최초 결제와 별도로 청구될 수 있습니다. 불편을 드려 죄송합니다.",
    create_shipping_address: "배송 받으실 주소를 등록하고 주문을 진행해 주세요.",
    description:
      "모든 거래는 안전하게 암호화됩니다.<br/>결제 정보를 저장하여 빠르고 편리하게 주문해 보세요. 일반 결제는 다른 결제 수단을 선택하여 이용할 수 있습니다.",
    use_as_billing_address: "청구 주소로 사용",
    pay_now: "결제",
    consent: "주문 내용을 모두 확인했으며, 스토어 및 결제대행 서비스(토스페이먼츠) 이용 약관에 동의합니다.",
    discount_code_alert: "* 협업 및 일부 컬렉션은 할인 코드 적용에서 제외됩니다.",
    discount_code_alert_description:
      "일부 컬렉션은 할인에서 제외되며 할인 코드가 적용된 주문을 취소했을 시 할인 코드는 재발급되지 않습니다.",
    wrong_customer_id: "고객 정보가 일치하지 않습니다. 지금 접속한 계정을 로그아웃 후 동일한 계정으로 다시 로그인해 주세요.",
    wrong_cart_amount: "장바구니 금액이 결제 금액과 일치하지 않습니다.",
    wrong_discount_name: "유효하지 않은 할인 코드 입니다.",
    wrong_discount_code: "유효하지 않은 할인 코드가 적용되었습니다. 다시 시도해 주세요.",
    wrong_cart_changed: "상품, 수량 또는 가격이 변경되어 장바구니가 업데이트되었습니다. 다시 시도해 주세요.",
    gifting_description: "소중한 사람에게 선물을 보내보세요.<br/>결제가 완료되면, 카카오톡으로 선물 메세지를 발송할 수 있습니다.",
    gifting_card_message: "보내시는 선물 메세지에 포함될 내용을 작성해주세요.",
    gifting_recipient: "선물 받는 사람이 본인에게 보낸 선물임을 알 수 있도록 수신자 이름을 가급적 실명으로 입력해 주세요.",
    discount_input: "할인코드를 입력하세요.",
    discount_code_placeholder: "할인 코드를 입력해 주세요.",
  },
  cart: {
    discount: "배송비 및 할인 코드 적용은 결제 단계에서 적용됩니다.",
    add_to_bag: "Add to Bag",
    delivery_benefit: "Delivery Benefit",
    free_shipping_at: "Free shipping at {{amount}}",
    free_shipping_remaining: "{{amount}} remaining",
    free_shipping_achieved: "This order qualifies for free shipping",
    checkout: "구매하기",
    preorder: "예약 발송 상품은 일반 상품과 함께 담을 수 없고, 현재 장바구니에서만 단독으로 구매할 수 있습니다.",
    amount: "주문 수량",
    go_to_checkout: "Proceed to Checkout",
    description: "Taxes and shipping calculated at checkout.",
    empty: "Oh your cart is empty!",
    add_to_cart: "Add to Cart",
    go_to_shop: "Continue Shopping",
  },
  order_completed: {
    description:
      "고객님의 주문이 정상적으로 처리되었습니다.<br/>주문 정보는 주문 내역 페이지에서 확인 가능하며 상품 발송 시 알림톡 및 이메일로 안내됩니다.",
  },
  product: {
    membership_auto_discount_notice: "멤버십 등급 할인이 적용되지 않는 상품입니다.",
    discount_code_unavailable_notice: "멤버십 할인 코드 적용이 불가한 상품입니다.",
    pigment_warning: "탈색 및 이염될 우려가 있으므로 세탁 및 착용 시 주의하시기 바랍니다.",
    preorder_description:
      "예약 발송 상품은 일반 상품과 배송 일정이 다르기 때문에 기존 장바구니와 별도로 이 화면에서 단독 상품 구매만 가능합니다.",
    pre_order_warning: "프리오더 상품 주문은 단건으로만 가능합니다.<br/>해당 상품을 카트에 담을 경우 기존 카트의 일반 상품은 삭제됩니다.",
    normal_items_warning:
      "프리오더 상품 주문은 단건으로만 가능합니다.<br/>해당상품을 카트에 담을 경우 기존 카트의 프리오더 상품은 삭제됩니다.",
    shipping: {
      description:
        "배송방법: 택배 (일반 배송)<br/>지역: 전국지역<br/>기간: 영업일 2일 ~ 5일<br/>안내: 도서산간 지역은 추가 금액을 지불하여야 하는 경우가 있습니다.<br/><br/>불량/오배송, 광고 내용과 다르게 배송된 경우에는 3개월 이내 접수해 주시기 바랍니다.<br/>배송 및 반품에 대한 자세한 내용은 아래 링크의 페이지에서 확인해 주세요.<information>{{domain}}</information>",
    },
    restock_notification: {
      description: "휴대전화 번호를 등록해 주시면 카카오 알림톡을 통해 품절된 상품의 재입고 여부를 알려드립니다.",
    },
  },
  collection: {
    empty: "죄송합니다. 현재 페이지에 준비된 상품이 없습니다.",
    ready: "컬렉션의 상품을 준비 중입니다.",
  },
  return: {
    reason: "Reasons",
    request: "Submit Request",
    request_description: "상품 상태에 따라 환불 예정 금액은 변경될 수 있으며, 반품 신청이 거부될 수 있습니다.",
    detail_reason: "Details",
    description: "반품 신청할 상품과 사유를 선택해 주세요.<br/>반품 신청은 주문 생성 후 7일 이내에만 가능합니다.",
    requested_description: "반품 신청이 완료되었습니다.<br/>반품 승인 혹은 거절 시 카카오 알림톡을 통해 안내드립니다.",
    view_policy: "배송 및 반품 약관 보기",
    detail_description: "관련 내용을 입력하세요.(선택)",
    additional_description:
      "반품 신청하실 상품 및 사유를 다시 한 번 확인해 주세요.<br/>반품 신청 내용이 약관에 어긋날 경우 신청이 거절될 수 있습니다.",
    image_description: "관련 사진을 업로드해주세요.",
    add_image: "관련 사진을 업로드해 주세요.",
    select_reason: "반품 사유를 선택해 주세요.",
    unwanted_notice: "단순 변심으로 인한 반품 시 배송비가 부과될 수 있습니다.",
    refund_shipping_notice: "{{reason}}으로 인한 반품 시 배송비가 부과될 수 있습니다.",
    disabled_product: "*해당 상품의 반품은 채널톡을 통해 문의해 주세요.",
    upload_image: "사진을 업로드해 주세요...",
    gift_description: "사은품은 지급 조건에따라 자동 선택됩니다.",
    return_reason: {
      title: "Return reason",
      unwanted: "단순 변심",
      default: "반품 사유 선택",
      defective: "상품 불량 및 오배송",
      size_large: "사이즈가 큼",
      size_small: "사이즈가 작음",
    },
    reasons: {
      defective: "상품 불량 및 오배송",
      unwanted: "단순 변심",
    },
    optional: "선택",
  },
  return_requested: {
    description: "반품 신청이 정상적으로 완료되었습니다.<br/>반품 승인 혹은 거절 시 카카오 알림톡을 통해 안내드립니다.",
    estimated_period: "최대 7일",
    button: "배송 및 반품 약관 보기",
    additional_charge: "*반품하려는 상품의 구매 가격이 반품 배송비보다 낮을 경우, 추가 반품 배송비를 부담해야 합니다.",
    title: "Return is requested.",
    estimated_refund_amount: "예상 환불금액",
    return_deadline: "반품 기한",
    return_shipping_fee: "반품 배송비",
  },
  search: {
    empty: '"{{value}}"에 대한 검색 결과가 없습니다. 다른 검색어로 시도해 보세요.',
    view_all: "전체 보기",
    placeholder: "검색어를 입력해 주세요.",
    alert: "검색어를 입력해주세요.",
    no_matches: "검색어와 일치하는 제품이 없습니다.",
  },
  membership: {
    title: "{{storeName}} 멤버십을 통해 특별 할인 혜택과 함께 신상품 소식 및 이벤트 정보를 가장 먼저 받아보세요.",
    higher: "{{currency}}{{amount}} 이상",
    lower: "{{currency}}{{amount}} 미만",
    discount: "상시 할인 {{amount}}%",
    discount_rate: "상시 할인율",
    coupon: "월간 코드 {{amount}}%",
    total_spent: "누적 구매 금액",
    left: "다음 등급까지 ₩{{amount}} 남았습니다.",
    total: "현재 누적 구매 금액은 ₩{{amount}}입니다.",
    view_membership: "나의 멤버십 정보 보기",
    description_text: "등급에 따른 상시 할인 혜택과 함께, 멤버십 회원에게만 제공되는 각종 할인 및 익스클루시브 컨텐츠를 만나보세요.",
    current_membership: "{{last_name}}{{first_name}}님의 등급은 <membership>{{membership}}</membership>입니다.",
    monthly_discount_code: "월간 할인코드",
    description: {
      "1": "회원 등급 혜택은 {{storeName}} 온라인 스토어에서만 적용 가능합니다.",
      "2": "등급은 매월 1일 오전 11시부터 순차적으로 변경되며, 최근 1년간의 누적 실 결제 금액을 기준으로 산정됩니다.",
      "3": "실 결제 금액은 할인 적용 후, 배송비를 제외한 순수 상품 금액을 기준으로 하며, 주문일로부터 7일이 경과한 이후부터 합산됩니다.",
      "4": "등급별 월간 할인 코드는 매월 1일 11:00부터 해당 익월 1일 10:59까지 사용 가능합니다.",
      "5": "일부 상품은 등급 혜택 및 할인 적용 대상에서 제외될 수 있습니다.",
      "6": "발급된 할인 코드는 사용과 동시에 소멸되며, 재발급 및 복원은 불가합니다.",
      "7": "멤버십 회원 등급 산정 기준은 총 주문 금액에서 각종 할인, 취소 및 환불 건을 제외한 실 결제 금액을 바탕으로 적용됩니다.",
      "8": "할인 코드 사용의 경우 한 주문 건당 한 개의 코드만 사용 가능하며 타 할인 코드와 중복 사용이 불가능합니다.",
      "9": "일부 상품의 경우 할인 및 혜택 대상에서 제외됩니다.",
      "10": "회원 등급에 따른 혜택은 타인 양도가 불가합니다. 부정적인 방법을 통해 누적한 실적으로 의심되는 경우, 회원 등급이 강등될 수 있습니다.",
      "11": "발급된 코드는 사용과 동시에 소멸되며, 재발급 및 복원이 불가합니다.",
    },
    policy: {
      "2": "회원 등급 혜택은 {{storeName}} 온라인 스토어에서만 적용 가능합니다.",
      "3": "등급별 할인 코드 혜택으로 매월 1일 오전 11시에 1회 사용할 수 있는 멤버십 전용 할인 코드가 발급되며, 익월 1일 오전 10시 59분까지만 사용 가능합니다. (마케팅 정보 수신 여부 및 마케팅을 위한 개인정보 수집 이용을 거부한 경우 각종 소식, 혜택에 제한이 있을 수 있습니다.)",
      "4": "등급 기준은 매월 1일 오전 11시부터 순차적으로 변경되며 변경일로부터 최근 1년 이내, 누적 실 결제금액 기준으로 적용됩니다.",
      "6": "할인 코드 사용의 경우 한 주문 건당 한 개의 코드만 사용 가능하며 타 할인 코드와 중복 사용이 불가능합니다.",
      "7": "일부 상품의 경우 할인 및 혜택 대상에서 제외됩니다.",
      "10": "발급된 코드는 사용과 동시에 소멸되며, 재발급 및 복원이 불가합니다.",
      "11": "발급된 코드는 사용과 동시에 소멸되며, 재발급 및 복원이 불가합니다.",
    },
  },
  success: {
    password_reset_email: "비밀번호 재설정 이메일이 발송되었습니다.",
    password_reset_social_email: "소셜로그인 계정은 비밀번호 재설정이 불가능합니다.",
    newsletter_subscribe_message: "이메일 인증을 완료하시면 뉴스레터를 구독하실 수 있습니다.",
    copy_url: "상품 주소가 복사되었습니다.",
    copy_url_message: "붙여넣기하여 상품 주소를 공유해 보세요.",
    modify_account_info: "회원 정보 수정이 완료되었습니다.",
    verification: "본인인증이 완료되었습니다.",
    raffle_entry: "응모가 완료되었습니다.",
    payment: "결제가 정상적으로 처리되었습니다.",
    newsletter_subscribe: "뉴스레터 구독 확인 메일이 발송되었습니다.",
    login: "로그인 되었습니다.",
    restock: "재입고 알림 등록이 완료되었습니다.",
    wishlist_add: "위시리스트 추가가 완료되었습니다.",
    wishlist_remove: "위시리스트 제거가 완료되었습니다.",
    address_remove: "주소 제거가 완료되었습니다.",
    logout: "로그아웃 되었습니다.",
    cancel_order: "주문 취소가 완료되었습니다.",
    validate_toss: "토스 임직원 확인이 완료되었습니다.",
    adult_verification: "성인 인증이 완료되었습니다.",
    password_change: "비밀번호가 변경되었습니다. 다시 로그인해 주세요.",
    register_complete: "회원 가입이 완료되었습니다.",
  },
  warning: {
    login: "이메일 또는 비밀번호가 올바르지 않습니다.",
    phone: "올바른 전화번호 형식으로 입력해 주세요.",
    phone_taken: "이미 등록된 전화번호 입니다.",
    add_cart: "구매 가능한 수량을 초과했습니다.",
    payment_cancel: "진행 중인 결제가 취소되었습니다. 결제를 완료하시려면 다시 시도해 주세요.",
    quantity_limit: "구매 가능한 수량을 초과했습니다.",
    quantity_insufficient:
      "주문하시려는 상품의 수량이 주문 과정에서 구매 가능 수량을 초과하였습니다. 장바구니에서 해당 상품의 수량이 구매 가능 수량에 맞게 조정되며 품절된 상품은 제거됩니다.",
    necessary_shipping_address: "상품을 수령할 배송지를 입력해 주세요.",
    necessary_invalid_shipping_address: "입력한 배송 주소가 잘못되었습니다. 배송받으실 주소가 올바른지 확인해 주세요.",
    necessary_payment_data: "결제 정보가 없습니다. 다시 시도해 주세요.",
    necessary_payment_method: "결제 수단을 선택해 주세요.",
    no_return_for_gift: "사은품만 반품할 수 없습니다.",
    no_return_product: "반품 신청할 상품을 선택해 주세요.",
    no_reason: "반품 사유를 선택해 주세요.",
    no_returnable_product: "주문 내역에 현재 반품이 불가능한 상품이 있습니다. 해당 상품은 고객 센터에 문의해 주세요.",
    no_quantity_product: "반품 신청할 수 없는 상품입니다.",
    same_account_info: "기존 고객 정보와 다른 값을 입력해주세요.",
    invalid_cart: "구매 가능한 상품이 없습니다.",
    reusable_bag_limit: "Reusable Carrier Bag은 단독으로 구매할 수 없습니다.",
    end_session: "세션이 만료되었습니다. 다시 로그인 해주세요.",
    fail_calculate_order: "주문 금액 계산에 실패하였습니다. 다시 시도해 주세요.",
    already_restock: "이미 재입고 알림이 신청된 전화번호 입니다.",
    gifting_necessary_receiver_name: "선물받는 분의 이름을 입력해 주세요.",
    gifting_necessary_sender_phone: "고객정보 페이지(<a>{{storeDomain}}/account</a>)에서 고객님의 전화번호를 저장하고 다시 시도해주세요.",
    gifting_necessary_message_content: "선물 메시지를 입력해 주세요.",
    no_login: "로그인이 필요합니다.",
    no_cart: "카트에 담긴 상품이 없습니다.",
    remove_product: "반품 신청 개수는 1개 이상이어야 합니다.",
    over_product: "반품 가능한 최대 개수만큼 선택되었습니다.",
    not_match_password: "현재 사용 중인 비밀번호를 정확하게 입력해 주세요.",
    same_password: "현재 비밀번호와 다른 비밀번호를 입력해 주세요.",
    no_detail_reason: "반품 상세 사유를 입력해 주세요.",
    no_image: "반품 사유와 관련된 사진을 업로드해주세요.",
    social_account: "{{social}}로 가입한 계정입니다. {{social}} 로그인을 이용해 주세요.",
    no_email: "가입되지 않은 이메일입니다.",
    checkout_shipping_address_blocked: "선택하신 주소는 이용약관에 의해 배송할 수 없는 주소입니다. 다른 주소를 사용해 주세요.",
    exceed_purchase_limit: "누적 주문 금액과 장바구니 금액의 합이 주문 금액 한도를 초과하였습니다. 장바구니 상품 및 금액을 조정해 주세요.",
    remaining_limit: "최대 주문 가능 금액: ₩{{amount}}",
    adult_only: "*Adults Only",
    separate_required:
      "장바구니에 성인 인증이 필요한 상품이 포함되어 있습니다.<br/>해당 상품은 일반 상품과 함께 결제가 불가능하오니 일반 상품과 별도로 주문해 주세요.",
    request_identity_verification: "장바구니에 성인 인증이 필요한 상품이 포함되어 있습니다.<br/>본인 인증을 통해 주문을 진행해 주세요.",
    need_identity_verification: "본인 인증이 취소되었습니다. 제품을 구매하시려면 다시 시도해 주세요.",
    fail_identity_verification: "본인 인증에 실패했습니다. 다시 시도해 주세요.",
    empty_cart: "카트에 담긴 상품이 없어 이전 페이지로 이동합니다.",
    necessary_billing_address: "청구지 주소를 입력해 주세요.",
    no_quantity_cart: "해당 제품은 재고 소진으로 인해 장바구니에 담을 수 없습니다.",
    newsletter_empty_email_title: "이메일을 입력해 주세요.",
  },
  error: {
    already_used_discount_code: "이미 사용한 할인코드입니다.",
    failed_api_discount_code: "할인코드 사용에 실패 하였습니다. 잠시 후 다시 시도해 주세요.",
    not_found: "존재하지 않는 URL 입니다.",
    payment: "결제가 정상적으로 완료되지 않았습니다. 다시 시도해 주세요.",
    necessary_country: "국가를 입력해 주세요.",
    necessary_lastName: "성을 입력해 주세요.",
    necessary_firstName: "이름을 입력해 주세요.",
    necessary_city: "도시를 입력해 주세요.",
    necessary_zip: "우편번호를 입력해 주세요.",
    necessary_province: "시/도를 입력해 주세요.",
    necessary_address1: "주소를 입력해 주세요.",
    necessary_address2: "상세 주소를 입력해 주세요.",
    necessary_phone: "전화번호를 입력해 주세요.",
    necessary_english: "영어, 숫자, 특수문자로만 입력해주세요.",
    invalid_phone: "전화번호를 정확하게 입력해 주세요.",
    invalid_birthday: "생년월일을 양식에 맞게 입력해 주세요. (ex. MM/DD/YYYY).",
    necessary_password: "비밀번호를 입력해 주세요.",
    necessary_new_password: "변경할 비밀번호를 입력해 주세요.",
    necessary_confirm_password: "변경할 비밀번호를 다시 한 번 입력해 주세요.",
    necessary_email: "이메일을 입력해 주세요.",
    match_password: "비밀번호가 일치하지 않습니다. 다시 확인해 주세요.",
    necessary_consent: "개인정보 수집 및 이용에 동의해 주세요.",
    failed_no_return_product: "반품 가능한 상품이 존재하지 않습니다.",
    exceed_qty: "구매 가능한 수량을 초과했습니다.",
    already_delete_account: "이미 탈퇴 처리 중인 계정입니다.",
    verification_error_description: "본인인증 처리에 오류가 발생했습니다.",
    verification_error_failure: "인증에 실패하였습니다. 다시 시도해주세요.",
    verification_none: "인증되지 않은 계정입니다.<br/>최초 1회 본인인증을 진행해 주세요.",
    raffle_already_entered: "이미 응모하신 상품입니다.",
    raffle_error: "응모 처리 중 오류가 발생했습니다.",
    blocked_address: "선택하신 주소는 이용약관에 의해 배송할 수 없는 주소입니다. 다른 주소를 사용해 주세요.",
    gifting_fetch_failed: "선물 정보를 불러오는 중 오류가 발생했습니다.",
    gifting_accept_failed: "선물 수락 처리 중 오류가 발생했습니다. 다시 시도해 주세요.",
    gifting_share_data: "선물 발송에 필요한 데이터를 불러오는 중 오류가 발생했습니다. 다시 시도해 주세요.",
    server: "서버에 에러가 발생했습니다. 잠시 후 다시 시도해 주세요.",
    search: "검색어를 입력해 주세요.",
    select_option: "옵션을 선택해 주세요.",
    discount_code: "유효하지 않은 할인코드입니다.",
    cancel_order: "주문 취소가 처리되지 않았습니다. 잠시 후 다시 시도해 주세요.",
    checkout: "결제페이지에서 에러가 발생했습니다. 잠시 후 다시 시도해 주세요.",
    invalid_phone_number: "전화번호를 정확하게 입력해 주세요.",
    invalid_english: "영문으로 입력해 주세요.",
    invalid_zip: "우편번호를 정확하게 입력해 주세요.",
    necessary_field: "필수 입력 항목입니다.",
    toss_payment: "결제 서비스에 오류가 발생했습니다. 다시 시도해 주세요.",
    server_title: "서버에 에러가 발생했습니다. 잠시 후 다시 시도해 주세요.",
    discount_code_title: "유효하지 않은 할인코드입니다.",
    already_used_discount_code_title: "이미 사용한 할인코드입니다.",
  },
  login: {
    invalid_email: "유효한 이메일을 입력해 주세요.",
    in_app_browser: "알림",
    in_app_browser_message:
      "현재 사용 중인 브라우저에서는 소셜 로그인 사용이 불가합니다.<br/>이메일 로그인 혹은 다른 브라우저를 이용해주세요.",
    account_disable:
      "해당 계정은 탈퇴 신청이 접수되어 현재 로그인 및 서비스 이용이 제한된 상태입니다.<br/>회원 계정 및 개인정보는 마지막 주문일 기준 최소 1일~최대 30일경과 후 자동 삭제되며, 삭제 완료 전까지 동일 이메일 주소로 재가입은 불가능합니다.<br/>스토어 이용을 원하실 경우 다른 이메일 주소로 신규 가입 후 이용 부탁드립니다.",
    min_password: "비밀번호는 최소 5개의 문자 이상이여야 합니다.",
    social: "소셜",
    kakao_continue: "카카오로 계속하기",
    google_continue: "구글로 계속하기",
    social_continue: "소셜 로그인으로 계속하기",
    email_continue: "이메일로 계속하기",
    reset_password: "비밀번호 재설정",
    register: "회원 가입",
    cancel: "취소하기",
    login: "로그인",
    send_email: "이메일 전송하기",
    connect: "계정과 연동되어 있습니다.",
    apply: "적용하기",
    info: "이메일, 비밀번호만 설정 후 회원가입 하시면 상품 결제, 주문 확인 및 배송 조회, 등급별 혜택 등 더욱 편리하게 스토어를 이용하실 수 있습니다.",
    personal_info: "개인정보 처리방침 및 이용약관 동의 (필수)",
    marketing_subscribe: "마케팅 정보 제공 수신 동의 (선택)",
    auth: "본인 인증하기",
    auth_ask: "보다 안전한 거래를 위해\n최초 1회 본인인증을 진행해 주세요.",
    verificaton_error: "인증에 실패하였습니다.",
    social_login_reset_password:
      "이메일로 비밀번호 재설정 링크를 발송해드리겠습니다.\n새로운 비밀번호로 변경 후 다시 소셜로그인을 시도해주세요.",
    description:
      "{{storeName}} 온라인 스토어의 회원이 되어보세요.<br /> 매달 제공되는 멤버십 혜택과 함께 결제, 주문내역 확인 및 배송 조회 등 더욱 편리하게 이용하실 수 있습니다.",
  },
  footer: {
    company1: "제이케이엔디 주식회사",
    company2: "사업자등록번호 361-86-01005",
    company3: "대표 조나단",
    company4: "서울특별시 성동구 아차산로 159(성수동2가, 제이케이앤디)",
    company5: "070-4048-5375",
    company6: "통신판매 2024-서울성동-1504",
  },
  information: {
    shipping: {
      method: "배송방법",
      method_description: "택배 (일반 배송)",
      zone: "지역",
      zone_description: "전국지역",
      time: "기간",
      time_description: "영업일 2일 ~ 5일",
      rate: "비용",
      rate_description: "무료",
      description: "도서산간 지역은 추가 금액을 지불하여야 하는 경우가 있습니다.",
    },
    info1: "스토어 이용 중 문의 사항이 있을 시에는 아래의 방법으로 문의해 주세요.",
    info2: "주문 취소 및 반품 신청, 배송 추적은 주문내역 페이지에서 가능합니다.",
    hours: "Hours",
    cs_time: "Mon - Fri 10am - 5pm",
    email: "{{serviceEmail}}",
    channel_talk: "{{channelTalkDomain}}",
  },
  news_letter: {
    accepts_marketing: "마케팅 활용 및 광고성 이메일 수신 동의",
  },
  not_found: {
    description: "요청하신 URL을 찾을 수 없습니다.",
  },
  events: {
    apply_form: "Submit Form",
    apply: "Apply Event",
    applied: "Thank you!",
    view_history: "View History",
    history_description: "*이벤트 신청 후 정보 수정을 원하시는 경우에는 아래 링크를 통해 이벤트 신청 내역에서 취소 후 재신청해 주세요.",
    applied_description: "신청이 완료되었습니다. 감사합니다.",
    agreement: "위 내용을 모두 확인하였으며, 이에 동의합니다.",
    require_agreement: "필수 동의 항목을 확인해주세요.",
    option_default: "옵션 선택",
    info: "신청자 정보",
    info_description: "선정되신 분들께는 개별적으로 안내드릴 예정이오니, 신청 시 반드시 연락 가능한 휴대전화번호를 기재해 주시기 바랍니다.",
    checkin_description:
      "신청 결과를 카카오 알림톡을 통해 안내 드리오니, 신청 시 반드시 연락 가능한 휴대전화번호를 기재해 주시기 바랍니다.",
    success_apply: "이벤트 신청이 완료되었습니다.",
    success_cancel: "이벤트 신청이 취소되었습니다.",
    already_applied: "이미 신청한 이벤트입니다.",
    closed: "신청 기간이 종료되었습니다.",
    failed_apply: "이벤트 신청에 실패하였습니다. 잠시 후 다시 시도해 주세요.",
    failed_cancel: "이벤트 신청을 취소하지 못했습니다. 잠시 후 다시 시도해 주세요.",
    cancel: "Cancel Application",
    empty: "신청 내역이 없습니다.",
    cancel_confirm: "이벤트 신청을 취소하시겠습니까?",
  },
  modal: {
    cancel_order: {
      description: "주문을 취소하시겠습니까?<br/>결제된 금액은 영업일로부터 최대 3~5일 이내로 환불됩니다.",
    },
    gifting_send_message: {
      description: "아래 버튼을 클릭하여 카카오톡 메시지를 통해 선물을 보내주세요.",
      button_description: "카카오톡 메세지를 통해 선물을 보내주세요.",
    },
  },
  return_reason: {
    wrong_item: "상품 오배송",
    defective: "상품 불량",
    size_large: "사이즈가 큼",
    size_small: "사이즈가 작음",
    unwanted: "단순 변심",
    default: "기타",
  },
  products: {
    recommendation: {
      newest: "최근 본 상품",
      featured: "추천 상품",
    },
    product: {
      desc: {
        title: "제품 설명",
      },
      sizeChart: {
        title: "사이즈",
        alert: "상세 사이즈는 상품의 특성 및 측정 방식에 따라 약간의 오차가 발생할 수 있습니다.",
      },
      rtnExchDelivery: {
        title: "배송 및 교환/환불",
        description:
          "일반배송 서비스 (CJ 대한통운)\n배송비: 5만원 이상 구매 시 무료배송\n배송기간: 2~4 영업일 (일부 상품의 경우, 사정에 따라 배송이 다소 지연될 수 있습니다.)\n교환/환불: 하단 메뉴의 교환 및 환불 내용을 확인하신 후 주문내역 페이지에서 반품 신청이 가능합니다.",
      },
      membership: {
        title: "멤버십",
        description: "{{storeName}} 멤버십을 통해 특별 할인 혜택과 함께 신상품 소식 및 이벤트 정보를 가장 먼저 받아보세요.",
      },
    },
  },
  order_status_message: {
    refunded: "환불이 완료되었습니다.",
    canceled: "주문이 취소되었습니다.",
    partially_refunded: "부분 환불이 처리되었습니다.",
    completed: "주문이 완료되었습니다.",
    return_requested: "반품 요청이 접수되었습니다.",
    return_approved: "반품 요청이 승인되었습니다.",
    shipped: "주문하신 상품이 배송 중입니다. 운송장 번호를 확인하세요.",
    partially_shipped: "일부 상품이 발송되었습니다.",
    partially_preparing: "일부 상품이 배송 준비 중입니다.",
    preparing: "상품이 배송 준비 중입니다.",
    scheduled: "예약 발송 전입니다.",
    scheduled_preparing: "예약 발송을 준비 중입니다.",
    completed_preparing: "예약 발송이 완료되었습니다.",
    paid: "결제가 완료되었습니다.",
    fulfilled: "주문하신 상품이 발송되었습니다.",
    unfulfilled: "아직 발송되지 않은 주문입니다.",
    pending: "결제 확인 중입니다.",
  },
  launches: {
    raffle: {
      title_winning_condition: "(당첨 조건)",
      title_raffle_schedule: "(응모 일정)",
      title_store_info: "(제품 수령 스토어 및 일정 안내)",
      title_warning_notice: "(유의 사항)",
      already_entered: "이미 해당 라플에 응모하셨습니다.",
    },
  },
  raffle: {
    entry: {
      description: "모든 거래는 안전하게 암호화됩니다.<br/>결제 정보를 저장하여 빠르고 편리하게 주문해 보세요.",
      online_terms_accept_description: "응모 내용을 모두 확인했으며, 라플 약관 및 당첨 시 자동 결제, 주문 처리되는 것에 동의합니다.",
      offline_terms_accept_description: "응모 내용을 모두 확인했으며, 상품 수령 방법 및 라플 약관에 동의합니다.",
      instagram_invalid_error: "인스타그램 ID를 정확하게 입력해 주세요.",
      online_payment_notice: "라플 당첨 시 등록하신 결제 수단으로 자동 결제됩니다.",
      offline_payment_notice: "라플 당첨 시 카카오 알림톡을 통해 상품 구매 기간 및 방법에 대한 안내를 드립니다.",
      instagram_info: "{{storeName}} 인스타그램 (<instagramLink>{{instagramHandle}}</instagramLink>) 팔로우 후 아이디를 입력해주세요.",
      loading_description: "페이지를 새로고침하거나 닫으면<br/>신청 중인 응모가 취소될 수 있습니다.",
    },
    entered: {
      description:
        "고객님의 응모가 정상적으로 처리되었습니다.<br />응모 정보는 응모 내역 페이지에서 확인 가능하며 당첨 시 알림톡으로 안내됩니다.",
    },
  },
  gifting: {
    receive: {
      sender_name: "{{senderName}}님이 보낸 선물입니다.",
      terms_accept_description: "개인 정보 수집 동의하기",
      shipping_expire_period: "배송지 입력 기한: {{date}}",
      expire_notice: "배송지 입력 유효기간 내 수락하지 않으면 주문이 자동으로 취소됩니다.",
      status_page_description: "선물하기 기능과 관련된 문의사항이 있으신 경우 상단 채팅 버튼을 통해 문의해 주세요.",
      canceled_page_description: "선물하기 기능과 관련된 문의사항이 있으신 경우 아래 버튼을 통해 채팅 문의를 남겨주세요.",
      contact: "고객 문의 남기기",
      canceled: "선물이 취소되었습니다.",
      expired: "선물이 만료되었습니다.",
      failed: "판매자의 요청에 의해 취소된 선물입니다.",
    },
  },
  loading: {
    payment: {
      title: "결제가 진행 중입니다.",
      description: "페이지를 새로고침하거나 닫으면<br/>진행 중인 결제가 취소될 수 있습니다.",
    },
  },
  toast: {
    error: {
      default: "서버에 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
    },
    account: {
      success: {
        register: "회원가입이 완료되었습니다.",
        login: "로그인 되었습니다.",
        logout: "로그아웃 되었습니다.",
        verify: "본인인증이 완료되었습니다.",
        password_reset: "{{email}}로 비밀번호 재설정 메일이 발송되었습니다.",
        disable_customer: "회원 탈퇴가 완료되었습니다.",
        modify_account_info: "내 정보가 수정되었습니다.",
      },
      warn: {
        current_password: "현재 비밀번호를 입력해 주세요.",
        new_password: "새 비밀번호를 입력해 주세요.",
        confirmed_password: "확인 비밀번호를 입력해 주세요.",
        login_password: "현재 사용 중인 비밀번호를 정확하게 입력해 주세요.",
        match_password: "새 비밀번호와 비밀번호 확인을 동일하게 입력해 주세요.",
        update_new_password: "현재 비밀번호와 다른 비밀번호를 입력해 주세요.",
        too_short: "비밀번호는 최소 5개의 문자 이상이여야 합니다.",
        shipping_address: "배송지 정보를 모두 입력해 주세요.",
        phone_valid: "유효한 전화번호를 입력해 주세요.",
        phone_verify: "다른 계정에 등록된 전화번호입니다. 해당 계정으로 로그인해 주세요.",
        phone_verify_alert:
          "이 전화번호는 이미 다른 계정에 등록되어있습니다.\n다시 한 번 확인해 주세요.\n\n이메일: {{email}}\n\n추가 문의사항이 있으신 경우 채널톡을 통해 문의해 주세요.",
        phone_verify_alert_with_social:
          "이 전화번호는 이미 다른 계정에 등록되어있습니다.\n다시 한 번 확인해 주세요.\n\n이메일: {{email}}\n소셜 로그인: {{social}}\n\n추가 문의사항이 있으신 경우 채널톡을 통해 문의해 주세요.",
        invalid_credentials: "이메일 또는 비밀번호가 올바르지 않습니다.",
        email_account: "이메일로 가입한 계정입니다. 이메일 로그인을 이용해 주세요.",
        social_account: "{{social}}로 가입한 계정입니다. {{social}} 로그인을 이용해 주세요.",
        social_account_taken: "이미 가입한 이메일입니다. {{social}} 로그인을 이용해 주세요.",
        social_kakao_script_error: "카카오 로그인 에러가 발생했습니다. 잠시 후 다시 시도해 주세요.",
        undefined: "잘못된 접근입니다.",
        end_session: "세션이 만료되었습니다. 다시 로그인 해주세요.",
        request_login: "멤버십 등급 확인이 필요한 URL입니다. 로그인 후 계속해 주세요.",
        has_no_access: "접속 가능한 멤버십 등급이 아닙니다.",
        block_account: "사용할 수 없는 계정입니다.",
      },
      error: {
        register_limit: "현재 접속자가 많아 회원가입 기능이 지연되고 있습니다.\n 잠시 후 시도해 주세요.",
        unidentified_customer: "고객을 찾을 수 없습니다.",
        unidentified_phone: "전화번호가 등록되지 않은 계정입니다.",
        server_error: "서버에 에러가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      },
    },
    product: {
      success: {
        copy_url: "해당 상품의 URL이 클립보드에 복사되었습니다.",
      },
      warn: {
        select_size: "사이즈를 선택해주세요.",
      },
      error: {
        exceed_qty: "구매 가능한 수량을 초과했습니다.",
      },
    },
    wishlist: {
      success: {
        delete_wish_item: "해당 상품을 위시리스트에서 삭제했습니다.",
        add_wish_item: "해당 상품을 위시리스트에 추가했습니다.",
      },
    },
    draw: {
      success: {
        entry: "응모가 완료되었습니다.",
      },
      warn: {
        entry_instagram: "인스타그램 계정을 입력해 주세요.",
      },
    },
    checkout: {
      warn: {
        checkout_shipping_address_empty: "저장된 배송지가 없습니다. 결제를 완료하시려면 배송지를 추가해 주세요.",
        checkout_shipping_address_blocked: "선택하신 주소는 이용약관에 의해 배송할 수 없는 주소입니다.\n다른 주소를 사용해 주세요.",
        wrong_discount_code: "유효하지 않은 할인코드입니다.",
        necessary_payment_data: "결제 정보가 없습니다. 다시 시도해 주세요.",
        discount_code_valid: "할인 코드를 입력해 주세요.",
      },
      error: {
        discount_code_valid: "유효하지 않은 할인코드입니다.",
        payment_info: "결제 정보가 없습니다. 다시 시도해 주세요.",
        payment_complete: "결제가 정상적으로 완료되지 않았습니다. 다시 시도해 주세요.",
      },
    },
    captcha: {
      success: {
        select_letter: "인증이 완료되었습니다.",
      },
      warn: {
        select_letter: "선택할 수 있는 글자 수를 초과하였습니다.",
        select_wrong_letter: "틀린 답을 제출하였습니다. 처음부터 다시 시도해 주세요.",
        write_wrong_letter: "틀린 답을 제출하셨습니다. 다시 시도해 주세요.",
      },
    },
    return: {
      warn: {
        no_reason: "반품 사유를 선택해 주세요.",
        no_detail_reason: "반품 상세 사유를 입력해 주세요",
        no_image: "반품 사유와 관련된 사진을 이미지를 업로드해 주세요.",
      },
      error: {
        failed_return: "반품 신청이 실패하였습니다. 다시 시도해 주세요.",
      },
    },
  },
  deactivate_account: "회원 탈퇴가 완료되었습니다.",
  close: "닫기",
  toss_policy: {
    "1": "토스 임직원 계정의 주문 금액 한도는 연 ₩2,000,000이며, 매년 1월 1일에 초기화됩니다.",
    "2": "누적 주문 금액과 장바구니 금액의 합이 주문 금액 한도를 초과하는 경우 주문을 진행할 수 없습니다. 장바구니 상품 및 금액을 조정하여 구매해 주세요.",
    "3": "상품의 할인율이 토스 임직원 할인 혜택으로 적용되는 할인율보다 높은 경우 상품 할인율만 적용됩니다.",
    "4": "일부 상품은 토스 임직원 할인 혜택이 적용되지 않으며, 할인 혜택이 적용되지 않은 상품을 구매하여도 누적 주문 금액에 포함됩니다.",
    "5": "토스 임직원 계정은 토스 임직원 할인 혜택을 제외한 별도의 할인 프로모션이 적용되지 않습니다.",
    "6": "퇴사 시에는 익월 1일에 계정이 비활성화 처리됩니다. 비활성화된 이후에는 로그인이 불가하여 문의사항이 있을 경우 우측하단 채널톡을 이용해주세요.",
  },
};

export default ko;
